import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./tnpsc-group-iv-workshop.module.css";
//import csatWebBanner from "../../assets/images/Tnpsc/TNPSC-GroupIV-Workshop.jpg";
//import csatMobBanner from "../../assets/images/Tnpsc/TNPSC-GroupIV-Mob-Workshop.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';


const TnpscWorkshop = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 4 Class cum Workshop | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group 4 Class cum Workshop | Shankar IAS Academy" />
            <meta name="description" content="Join Shankar IAS Academy's TNPSC Group 4 Class cum Workshop 2025. Expert guidance, practical strategies. Enroll now to excel in Group 4 exams!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-iv-workshop/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 4 Class cum Workshop | Shankar IAS Academy" />
            <meta property="og:description" content="Join Shankar IAS Academy's TNPSC Group 4 Class cum Workshop 2025. Expert guidance, practical strategies. Enroll now to excel in Group 4 exams!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-iv-workshop/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="upsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                <h1 className={`${styles.sectiontitle}`}>TNPSC Group IV Class cum Workshop 2025</h1>
                </div>
            </div>

            {/* <div className="container">
            <div className="row d-none d-md-block">
                <div className="py-3 py-md-2">
                    <Image src={csatWebBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                </div>
            </div>

            <div className="row d-block d-md-none">
            <div className="py-3 py-md-2">
                    <Image src={csatMobBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                </div>
            </div>
            </div> */}

           


            <section  id="courseandfees">
                <div className="container pt-xl-4">
                    <div className={`${styles.title} `}>
                        <div className={`${styles.title1}  p-1`}>
                        <p>TNPSC Group IV Class cum Workshop </p>
                        </div>
                    </div>
                  
                    
                        <div className="row">
                            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block `}>Center</div>
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Batch</div>
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Starts On</div>
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Fee</div>
                           {/* <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Schedule</div> */}
                            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`}>Payment</div>

                            <hr/>
                        </div>
                    
                    
                        <div className={`${styles.facultyborder3} row`}>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0`}>Chennai-Anna Nagar</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Batch</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0`}>Regular (Offline/Online)</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Starts On</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0`}>25th Feb 2025</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0`}>₹15,000</div>
                           {/* <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Schedule </div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0`}>Coming Soon</div> */}
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block`}>Payment</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-2`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                            
                            <hr/>
                        </div>
               
                </div>
            </section>	

              {/* <div className="container">
                <div className="py-3 py-md-2">
                    <Image src={csatWebBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                </div>
                <div className='py-2' style={{ backgroundColor: "#001e62" }}>
                    <h2 className={`${styles.tabletitle}`}>Comprehensive Class-cum-Workshop for TNPSC Group IV Examination 2023</h2>
                </div>
                <div className="d-none d-lg-block">
                <div className={`${styles.tablescroll} prelimstable `}>
                    <table className="table">
                        <thead className={`${styles.table}`} >
                            <tr>
                                <td className={`${styles.tableheading}`}>Center<br /></td>
                                <td className={`${styles.tableheading}`}>Batch<br /></td>
                                <td className={`${styles.tableheading}`}>Starts On<br /></td>
                                <td className={`${styles.tableheading}`}>Fee<br /></td>
                                <td className={`${styles.tableheading}`}>Schedule<br /></td>
                                <td className={`${styles.tableheading}`}>Instruction<br /></td>
                                <td className={`${styles.tableheading}`}>Payment<br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Chennai-Anna Nagar<br /></td>
                                <td className={`${styles.tablepara}`}>Regular (Offline/Online)<br /></td>
                                <td className={`${styles.tablepara}`}>11th December 2023<br /></td>
                                <td className={`${styles.tablepara}`}>₹15000<br /></td>
                                <td className={`${styles.tablepara}`}><Link href="/pdf/tnpsc_workshop/REGULAR-CLASS-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td className={`${styles.tablepara}`}><Link href="/pdf/tnpsc_workshop/GROUP-IV-Instructions-Regular-Class.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div> */}


            <Footer />
        </>
    )
}

export default TnpscWorkshop;